import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import ClassNames from 'classnames';
import React, { useState } from 'react';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    margin: '16px 24px',

    alignItems: 'center',
    height: '30px',
    '&>div:nth-child(1)': {
      marginRight: '20px',
      '@media only screen and (max-width: 425px)': {
        marginRight: '12px',
      },
    },
    '@media only screen and (max-width: 1100px)': {
      width: '800px',
      paddingRight: '16px',
    },

    '@media only screen and (max-width: 768px)': {
      width: '401px',
    },
    '@media only screen and (max-width: 460px)': {
      width: '320px',
    },
    '@media only screen and (max-width: 400px)': {
      width: '270px',
    },
  },

  numberBox: {
    fontSize: '16px',

    '&.active': {
      fontWeight: 600,
      fontSize: '18px',
      paddingBottom: '1px',
    },

    '@media only screen and (max-width: 425px)': {
      fontSize: '16px',
    },
  },
  pageNum: {
    width: '24px',
    cursor: 'pointer',
    height: '24px',
    marginRight: '20px',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '@media only screen and (max-width: 425px)': {
      fontSize: '14px',
      marginRight: '10px',
    },
  },
  iconBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '1px',
    '@media only screen and (max-width: 425px)': {},
  },
  leftIcon: {
    fontSize: '16px',
    marginRight: '8px',
    cursor: 'pointer',

    '@media only screen and (max-width: 425px)': {
      marginRight: '4px',
    },
  },
  rightIcon: {
    fontSize: '16px',
    cursor: 'pointer',
    marginLeft: '8px',

    '@media only screen and (max-width: 425px)': {
      marginLeft: '4px',
    },
  },
});
export default function PagiNation(props) {
  const { postsPerPage, totalPosts, paginate, prevClick, nextClick, prevPageClick, nextPageClick, currentNum } = props;
  const pageNumbers = [];
  const [pageNum, setPageNum] = useState(1);

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageLeft = () => {
    if (Math.ceil(currentNum / 5) <= 1) {
      return;
    } else setPageNum(pageNum - 1);
    prevPageClick();
  };

  const handleLeft = () => {
    if (currentNum <= 1) {
      return;
    }
    if (currentNum % 5 === 1 && currentNum !== 1) {
      setPageNum(pageNum - 1);
    }
    prevClick();
  };

  const handleRight = () => {
    if (Math.ceil(totalPosts / postsPerPage) <= currentNum) {
      return;
    }
    if (currentNum % 5 === 0) {
      setPageNum(pageNum + 1);
    }

    nextClick();
  };
  const handlePageRight = () => {
    if (Math.ceil(pageNumbers.length / 5) <= pageNum) {
      return;
    } else setPageNum(pageNum + 1);
    nextPageClick();
  };
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box>
        {pageNumbers.length !== 1 ? (
          <Box className={classes.iconBox}>
            <KeyboardDoubleArrowLeftIcon className={classes.leftIcon} onClick={handlePageLeft}></KeyboardDoubleArrowLeftIcon>
            <KeyboardArrowLeftIcon className={classes.leftIcon} onClick={handleLeft}></KeyboardArrowLeftIcon>
          </Box>
        ) : (
          <Box></Box>
        )}
      </Box>
      {pageNumbers.map((number, i) => {
        if (pageNum * 5 >= number && pageNum * 5 - 4 <= number)
          return (
            <Box key={number}>
              <Box className={ClassNames({ [classes.numberBox]: true, active: number === currentNum })} onClick={() => paginate(number)}>
                <Box className={classes.pageNum}>{number}</Box>
              </Box>
            </Box>
          );
        else return '';
      })}
      <Box>
        {pageNumbers.length !== 1 ? (
          <Box className={classes.iconBox}>
            <KeyboardArrowRightIcon className={classes.rightIcon} onClick={handleRight}></KeyboardArrowRightIcon>{' '}
            <KeyboardDoubleArrowRightIcon className={classes.rightIcon} onClick={handlePageRight}></KeyboardDoubleArrowRightIcon>
          </Box>
        ) : (
          <Box></Box>
        )}
      </Box>
    </Box>
  );
}
